<template>
  <span>
    <router-link
      v-if="link"
      :to="link"
    >
      {{ title }}
    </router-link>
    <span v-else>
      {{ title }}
    </span>
  </span>
</template>

<script>
import articleMixin from '@/views/articles/Mixin'

export default {
  mixins: [articleMixin],
  props: {
    audit: {
      type: Object,
      default: () => ({}),
    },

    morph: {
      type: String,
      required: true,
    },
  },

  computed: {
    link () {
      switch (this.type) {
        case 'Alert':
          if (this.audit && this.audit.relation && this.audit.relation.id !== undefined && this.relationType) {
            return {
              name: `${this.relationType}s.view`,
              params: {
                [`${this.relationType}Id`]: this.audit.relation.id,
              },
            }
          }

          return false

        default:
          if (this.what && this.what.id !== undefined) {
            return {
              name: `${this.type.toLowerCase()}s.view`,
              params: {
                [`${this.type.toLowerCase()}Id`]: this.what.id,
              },
            }
          }

          return false
      }
    },

    what () {
      if (!this.audit) {
        return {}
      }

      return this.audit[this.morph] || {}
    },

    type () {
      if (!this.audit || !this.what) {
        return null
      }

      const type = this.audit[this.morph + '_type']

      return type ? type.substr(type.lastIndexOf('\\') + 1) :
        this.morph === 'who'
        ? 'user'
        : this.morph
    },

    relationType () {
      if (!this.audit || !this.what) {
        return null
      }

      const type = this.audit.relation_type

      return type ? type.substr(type.lastIndexOf('\\') + 1).toLowerCase() : ''
    },
    title () {
      /**
       *           case 'Followed':
          case 'Unfollowed':
          case 'Updated follow':
       */
      if (['Followed', 'Unfollowed', 'Updated follow'].indexOf(this.audit.action.action) !== -1) {
        let tags = ''

        if (this.audit.data && this.audit.data.tags) {
          const t = this.audit.data.tags
          t.forEach((t) => tags += (t.isExclusion ? ' - ' : ' + ') + t.tag.name)
        }

        return this.what.name + tags
      }

      if (!this.what) {
        return '—'
      }

      if (this.what.name) {
        return this.what.name
      }

      if (this.what.title) {
        return this.articleHeader(this.what)
      }

      if (this.what.subject) {
        return this.what.subject
      }

      return this.what.type ? this.what.type.substr(this.what.type.lastIndexOf('\\') + 1) : '-'
    },
  },
}
</script>
